import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../component-base';
import { AuthService } from '../../services/authentication/auth.service';
import { UserTaskCountDto } from '../../models/user';
import { CurrentUserService } from '../../services/current-user.service';

@Component({
  selector: 'current-user-info',
  templateUrl: './current-user-info.component.html'
})
export class CurrentUserInfoComponent extends BaseComponent implements OnInit {
  @Input() showInSideMenu: boolean = false;
  @Input() showInReviewPane: boolean = false;
  userTaskCountDto: UserTaskCountDto;

  constructor(public authService: AuthService,
    public override currentUserService: CurrentUserService) {
    super();
  }
  ngOnInit() {
    if (this.showInSideMenu) {
      //this.getUserTasksCount();
    }
  }
}
